import React from 'react';
import { Assistant } from '@/types';
import { renderAssistantIcon } from '@/utils/RenderAssistantIcon';

interface SuggestedPromptsProps {
    prompts: string[];
    assistant: Assistant;
    onPromptClick: (prompt: string) => void;
}

export const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({
                                                                      prompts,
                                                                      assistant,
                                                                      onPromptClick
                                                                  }) => {
    const extractColorsFromGradient = (gradient: string): string[] => {
        const colorMatches = gradient.match(/#[0-9a-fA-F]{3,6}|rgb\([^)]+\)|rgba\([^)]+\)|hsl\([^)]+\)|hsla\([^)]+\)/g);
        return colorMatches || [];
    };

    const gradientColors = extractColorsFromGradient(assistant.bgGradient);
    const primaryColor = gradientColors[0] || assistant.accentColor || '#6366f1';
    const secondaryColor = gradientColors[1] || primaryColor;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 sm:gap-2 md:gap-3 w-full max-w-lg px-1 sm:px-0">
            {prompts.map((prompt, index) => (
                <button
                    key={index}
                    onClick={() => onPromptClick(prompt)}
                    className="p-1.5 sm:p-2 md:p-3 text-left text-[11px] sm:text-xs md:text-sm bg-gray-700 rounded-lg hover:bg-gray-600 hover:shadow-lg transition-all group border"
                    style={{
                        backgroundColor: '#404040',
                        borderColor: primaryColor,
                        borderWidth: '1px'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = secondaryColor;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = primaryColor;
                    }}
                >
                    <div className="flex items-start gap-1 sm:gap-1.5 md:gap-2">
                        <div className="mt-0.5 group-hover:scale-110 transition-transform flex items-center justify-center flex-shrink-0">
                            {renderAssistantIcon({
                                assistant,
                                iconColor: primaryColor,
                                size: 'sm'
                            })}
                        </div>
                        <span className="text-gray-100 leading-tight text-[11px] sm:text-xs md:text-sm">{prompt}</span>
                    </div>
                </button>
            ))}
        </div>
    );
};